import Vue from "vue";
import nl from "vee-validate/dist/locale/nl";
import VeeValidate, { Validator } from "vee-validate";

export default (): void => {
  Validator.localize("nl", nl);
  Vue.use(VeeValidate, {
    locale: "nl",
  });
};
